import {
    ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_SUCCESS,
    ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_FAILED,
    LOADING_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE,
    RESET_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE,
    NETWORK_ERROR_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE:
            return (state = initialState);
        default:
            return state;
    }
};
